import React, { useState } from 'react';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';

// import JS files
import MuiButton from '../../shares/MuiButton';
import { useCustomerBasket } from '../../../context/CustomerBasketContext';
import BasketBoxInside from './BasketBoxInside';
import MuiBadge from '../../shares/MuiBadge';
import PanelDrawer from '../../shares/PanelDrawer';

// import Others files
const BasketBox = (props) => {
  const { userSelectedRing, clearBasket } = useCustomerBasket();

  const [openDrawer, setOpenDrawer] = useState(false);
  const toggleDrawer = () => {
    setOpenDrawer((before) => !before);
  };

  return (
    <>
      {/* Desktop Design */}
      <div className="hidden md:block mb-6">
        <BasketBoxInside
          setOpenDrawer={setOpenDrawer}
          AdminCreateOrderForUser={props.AdminCreateOrderForUser}
          selectedCustomer={props.selectedCustomer}
          setSelectedUser={props.setSelectedUser}
          setSelectedCustomer={props.setSelectedCustomer}
          isAdmin={props.isAdmin}
        />
      </div>
      {/* End of Desktop Design */}

      {/* Mobile Design */}
      <div className="md:hidden">
        <div className="add-item-container">
          <span className="text">
            برای مشاهده محصولات انتخاب‌شده روی دکمه سبد خرید کلیک کنید.
          </span>
          <div className="flex  py-1 md:hidden justify-around items-center mx-4">
            <MuiBadge count={userSelectedRing.length}>
              <MuiButton
                onClick={() => toggleDrawer()}
                variant="contained"
                icon={<AddShoppingCartIcon />}
                color="secondary"
                text="سبد خرید"
              />
            </MuiBadge>
          </div>
        </div>
      </div>
      {/* End of Mobile Design */}
      <PanelDrawer
        anchor="left"
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
      >
        <div className="bg-slate-100 max-w-xs h-full px-6 py-4">
          <BasketBoxInside
            setOpenDrawer={setOpenDrawer}
            AdminCreateOrderForUser={props.AdminCreateOrderForUser}
            selectedCustomer={props.selectedCustomer}
            setSelectedUser={props.setSelectedUser}
            setSelectedCustomer={props.setSelectedCustomer}
            isAdmin={props.isAdmin}
          />
        </div>
      </PanelDrawer>
    </>
  );
};

export default BasketBox;
